import { useEffect, useMemo } from 'react'
import Select from 'react-select'
import { FaFilter } from 'react-icons/fa'
import { VscClearAll } from 'react-icons/vsc'
import selectStyles from '../../shared/css/SelectStyle'
import Input from '../../shared/components/form/input'
import Button from '../../shared/components/Button/Button'

const ACTION_OPTIONS = [
    { value: 'all', label: 'Todas' },
    { value: 'create', label: 'Criar' },
    { value: 'update', label: 'Editar' },
    { value: 'delete', label: 'Apagar' },
]

function HistoricFilterModal({ filters, onChange, onClear, onClose, historics }) {

    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose() }
        document.addEventListener('keydown', onKey)
        return () => document.removeEventListener('keydown', onKey)
    }, [onClose])

    const entityOptions = useMemo(() => {
        const map = new Map()
        ;(historics || []).forEach((item) => {
            if (item.entity && !map.has(item.entity)) {
                map.set(item.entity, { value: item.entity, label: item.entity })
            }
        })
        return Array.from(map.values()).sort((a, b) => a.label.localeCompare(b.label))
    }, [historics])

    return (
        <div className="fm-overlay" onClick={onClose}>
            <div className="fm-box" onClick={(e) => e.stopPropagation()}>

                {/* ── Header ── */}
                <div className="fm-header">
                    <div className="fm-header-top">
                        <div className="fm-header-left">
                            <FaFilter size={24} className="fm-header-icon" />
                            <div>
                                <p className="fm-title">Filtrar histórico</p>
                                <span className="fm-accent" />
                            </div>
                        </div>
                        <button className="fm-close shd-modal-close" onClick={onClose}>X</button>
                    </div>
                    <div className="fm-header-actions">
                        <Button variant="cancel" icon={VscClearAll} onClick={onClear}>Limpar</Button>
                    </div>
                </div>

                {/* ── Body ── */}
                <div className="fm-body">

                    <div className="fm-section">
                        <span className="fm-label">Ação</span>
                        <div className="fm-status-row">
                            {ACTION_OPTIONS.map((opt) => (
                                <button
                                    key={opt.value}
                                    className={`fm-status-opt ${filters.action === opt.value ? 'fm-status-opt-active' : ''}`}
                                    onClick={() => onChange('action', opt.value)}
                                >
                                    {opt.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="fm-section">
                        <span className="fm-label">Entidade</span>
                        <Select
                            options={entityOptions}
                            onChange={(opt) => onChange('entity', opt)}
                            styles={selectStyles}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            value={filters.entity || null}
                            placeholder="Todas as entidades"
                            isClearable
                        />
                    </div>

                    <div className="fm-section">
                        <span className="fm-label">Período</span>
                        <div className="hist-filter-date-row">
                            <div className="hist-filter-date-col">
                                <Input
                                    type="date"
                                    name="dateFrom"
                                    text="De"
                                    value={filters.dateFrom || ''}
                                    handleOnChange={(e) => onChange('dateFrom', e.target.value)}
                                />
                            </div>
                            <div className="hist-filter-date-col">
                                <Input
                                    type="date"
                                    name="dateTo"
                                    text="Até"
                                    value={filters.dateTo || ''}
                                    handleOnChange={(e) => onChange('dateTo', e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}

export default HistoricFilterModal
